export default class Tour {
    constructor($el) {
        this.$el = $el;
        this.initListeners();
    }

    initListeners() {
        this.$el.addEventListener('tabs-change', e => {
            const view = e.detail.tab.dataset.tourView;
            this.$el.classList.remove('view-admin', 'view-user');
            this.$el.classList.add(`view-${view}`);
        });
    }
}
